'use client';

import { usePathname, useSearchParams } from 'next/navigation';
import { TbScubaDivingTank, TbScubaDivingTankFilled, TbScubaMask } from 'react-icons/tb';
import { 
  GiScubaTanks,
  GiMantaRay,
  GiTurtle,
  GiIsland,
  GiDivingHelmet
} from 'react-icons/gi';
import { LuWaves } from 'react-icons/lu';
import { FaRegCompass } from 'react-icons/fa';
import { MdScubaDiving, MdOutlineDirectionsBoatFilled } from 'react-icons/md';

import CategoryBox from "../CategoryBox";
import Container from '../Container';


export const categories = [
  {
    label: 'Snorkel',
    icon: TbScubaMask,
    description: `Don't you dare to dive? Book a sonorkel experience`,
  },
  {
    label: 'Intro',
    icon: GiDivingHelmet,
    description: 'What are you waiting for to try scuba diving?',
  },
  {
    label: 'Open Water',
    icon: LuWaves,
    description: 'Get certified as an Open Water diver!',
  },
  {
    label: 'Advanced OW',
    icon: FaRegCompass,
    description: 'Get certified as an Advanced Open Water diver!'
  },
  {
    label: 'Rescue',
    icon: MdOutlineDirectionsBoatFilled,
    description: 'Get certified as a Rescue diver!'
  },
  {
    label: 'Divemaster',
    icon: GiTurtle,
    description: 'Get certified as a Divemaster!'
  },
  {
    label: 'FUN DIVES',
    icon: GiIsland,
    description: 'If you are certified diver. Time for fun!'
  },
  {
    label: 'Instructor',
    icon: GiMantaRay,
    description: 'Get certified as an Instructor!'
  },
  {
    label: 'Nitrox',
    icon: TbScubaDivingTank,
    description: 'Get your nitrox specialty done!'
  },
  {
    label: 'Deep',
    icon: MdScubaDiving,
    description: 'Get your deep specialty done!'
  },
  {
    label: 'Other Specialties',
    icon: GiScubaTanks,
    description: 'Get your favorite specialty done!'
  },
  {
    label: 'Packs',
    icon: TbScubaDivingTankFilled,
    description: 'Save money doing few specialties at the same time!'
  }
]

const Categories = () => {
  const params = useSearchParams();
  const category = params?.get('category');
  const pathname = usePathname();
  const isMainPage = pathname === '/' || pathname === '/search';

  if (!isMainPage) {
    return null;
  }
  
  return (
    <Container>
      <div
        className="
          pt-7
          flex 
          flex-row 
          items-center 
          justify-between
          overflow-x-auto
          scrollbar 
          scrollbar-thumb-gray-400 
          scrollbar-track-gray-300
        "
      >
        {categories.map((item) => (
          <CategoryBox 
            key={item.label}
            label={item.label}
            icon={item.icon}
            selected={category === item.label}
          />
        ))}
      </div>
    </Container>
  );
}
 
export default Categories;